import React from 'react';
import { ChannelsText, CreateTopic, EditTopic, FlexForLogoDiv, H3TitleForInsta, HeaderWrapper, InstagramImgDiv, PTitleforInsta, QueryPara, Span1, Span2, StyledContainer, TwitterText } from './ReportHeader.styled';
import { Icon } from '@mui/material';
import { FacebookLogoSmall, InstagramIconSmall, LinkedInIcon, NewsLogo, StyledAddIcon, X_icon, YouTubeRedIcon } from '../../Common/SvgIcon/CommonSvgIcons';
import { Verified, EditOutlined } from '@mui/icons-material';
import { ProfileImage } from './PictureResolution';
import { formatNumber } from '../../utils/NumberFormatter';
import EnterpriseIcon from '../../assests/images/EnterpriseIcon.png'

const ReportHeaderFile = ({ topicPreviewData, handleCreatedTopic, handleRedirectNexus, job_id, onEdit }) => {


    const transformText = (inputText) => {
        if (inputText == 'twitter') {
            return ' ';
        }
        const words = inputText?.split(' ');
        const transformedWords = words?.map(word => word?.charAt(0).toUpperCase() + word?.slice(1));
        return transformedWords?.join(' ')
    };

    return (

        <HeaderWrapper>
            <Span1>{transformText(topicPreviewData?.title)}</Span1>
            <Span2 style={{ width: typeof job_id !== 'number' ? '80%' : '100%' }}>{topicPreviewData?.description}</Span2>
            {
                topicPreviewData?.channel == 'enterprise' ? <></>
                    :

                    <StyledContainer>
                        <ChannelsText>Channel:</ChannelsText>
                        <TwitterText>
                            <Icon>{topicPreviewData?.channel === 'twitter' ? X_icon : topicPreviewData?.channel === 'news' ? NewsLogo : topicPreviewData?.channel === 'instagram' ? InstagramIconSmall : topicPreviewData?.channel === 'facebook' ? FacebookLogoSmall : topicPreviewData?.channel === 'youtube' ? YouTubeRedIcon :
                                topicPreviewData?.channel === 'enterprise' ?
                                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img src={EnterpriseIcon} style={{ width: '20px', height: '20px' }} />
                                    </div> : ''}</Icon>
                            {topicPreviewData?.channel == 'twitter' ? '' : transformText(topicPreviewData?.channel)}
                        </TwitterText>
                    </StyledContainer>
            }
            {
                topicPreviewData?.channel == 'youtube' && topicPreviewData?.youtube_search_type == 'page' ?
                    <div>
                        <FlexForLogoDiv>
                            <InstagramImgDiv>
                                {topicPreviewData?.profile_pic_url ?
                                    <ProfileImage
                                        src={topicPreviewData?.profile_pic_url}
                                        fallbackSrc={'https://your-dynamic-fallback-url.com/default.jpg'}
                                    />
                                    :
                                    <div style={{ width: '80px', height: '80px', borderRadius: '50%', border: '1px solid #f4f0f0' }} ></div>
                                }
                            </InstagramImgDiv>
                            <div>
                                <H3TitleForInsta>{topicPreviewData?.user_name || decodeURIComponent(topicPreviewData?.user_name || '')}
                                    <span style={{ color: 'rgb(25, 118, 210)', height: '23px', marginLeft: '8px' }}>
                                        {/*  */}
                                        {topicPreviewData?.search_type == "user" && topicPreviewData?.verified == true && <Verified />}
                                    </span></H3TitleForInsta>
                                <PTitleforInsta>{topicPreviewData?.full_name || ''}</PTitleforInsta>
                                <PTitleforInsta>

                                    {topicPreviewData?.category || ''} {(`${formatNumber(topicPreviewData?.followers) || 0} subscribers`)
                                    }
                                </PTitleforInsta>

                                <PTitleforInsta>
                                    {topicPreviewData?.page_description}
                                </PTitleforInsta>
                            </div>
                        </FlexForLogoDiv>

                    </div>
                    :
                    topicPreviewData?.channel == 'facebook' && topicPreviewData?.facebook_search_type == 'pages' ?
                        <div>
                            <FlexForLogoDiv>
                                <InstagramImgDiv>

                                    <img src={topicPreviewData?.profile_pic_url || ''} alt='' style={{ width: '80px', height: '80px', borderRadius: '50%' }} />

                                </InstagramImgDiv>
                                <div>
                                    <H3TitleForInsta>{topicPreviewData?.user_name || decodeURIComponent(topicPreviewData?.user_name || '')}
                                        <span style={{ color: 'rgb(25, 118, 210)', height: '23px', marginLeft: '8px' }}>
                                            {/*  */}
                                            {topicPreviewData?.search_type == "user" && topicPreviewData?.verified == true && <Verified />}
                                        </span></H3TitleForInsta>
                                    <PTitleforInsta>{topicPreviewData?.full_name || ''}</PTitleforInsta>
                                    <PTitleforInsta>

                                        {topicPreviewData?.category || ''} {(`${formatNumber(topicPreviewData?.followers) || 0} followers`)
                                        }
                                    </PTitleforInsta>

                                    <PTitleforInsta>
                                        {topicPreviewData?.description || topicPreviewData?.page_description}
                                    </PTitleforInsta>
                                </div>
                            </FlexForLogoDiv>

                        </div>
                        :
                        topicPreviewData?.channel == 'instagram' && topicPreviewData?.search_type == 'hashtag' ?
                            <div>
                                <FlexForLogoDiv>
                                    <InstagramImgDiv>

                                        <div style={{
                                            width: '70px', borderRadius: '50%', fontSize: '50px', textAlign: 'center', color: ' #2a2929'

                                        }}>#</div>

                                    </InstagramImgDiv>
                                    <div>

                                        <H3TitleForInsta>{topicPreviewData?.user_name && `#${topicPreviewData?.user_name}` || ''}</H3TitleForInsta>
                                        <PTitleforInsta>{`${formatNumber(topicPreviewData?.engagement)} posts` || ''}</PTitleforInsta>
                                    </div>
                                </FlexForLogoDiv>

                            </div>
                            :
                            topicPreviewData?.channel == 'instagram' && topicPreviewData?.search_type == 'user' ?
                                <div>
                                    <FlexForLogoDiv>
                                        {
                                            topicPreviewData?.profile_pic_url &&
                                            <InstagramImgDiv>

                                                <img src={topicPreviewData?.profile_pic_url || ''} alt='drc' style={{ width: '80px', height: '80px', borderRadius: '50%' }} />

                                            </InstagramImgDiv>
                                        }
                                        <div>
                                            <H3TitleForInsta>{topicPreviewData?.user_name || decodeURIComponent(topicPreviewData?.user_name || '')}
                                                <span style={{ color: 'rgb(25, 118, 210)', height: '23px', marginLeft: '8px' }}>
                                                    {/*  */}
                                                    {topicPreviewData?.search_type == "user" && topicPreviewData?.verified == true && <Verified />}
                                                </span></H3TitleForInsta>
                                            <PTitleforInsta>{topicPreviewData?.full_name || ''}</PTitleforInsta>
                                            <PTitleforInsta>
                                                {
                                                    topicPreviewData?.search_type == "user" ?
                                                        `${topicPreviewData?.engagement ? `${formatNumber(topicPreviewData?.engagement)} followers` : ''}`
                                                        : topicPreviewData?.search_type == "hashtag" ?
                                                            `${formatNumber(topicPreviewData?.engagement)} posts` :
                                                            ''}
                                            </PTitleforInsta>
                                        </div>
                                    </FlexForLogoDiv>

                                </div>
                                :
                                topicPreviewData?.channel == 'enterprise' ?
                                    <></>
                                    :
                                    <QueryPara>
                                        <b>Query Used:&nbsp;</b> <span style={{ cursor: topicPreviewData?.channel == 'instagram' ? 'pointer' : '' }}>{topicPreviewData?.keywords_string}</span>
                                        <br />
                                        {/* <br /> lang: en since: 2023-01-01 until: 2023-05-18 geocode: 20.5937,78.9629,2000 km */}
                                    </QueryPara>
            }
            {typeof job_id !== 'number' && (
                <div style={{
                    position: 'absolute',
                    right: '20px',
                    top: '20px',
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center'
                }}>
                    {topicPreviewData?.channel === 'twitter' && (
                        <EditTopic onClick={onEdit}>
                            Edit <EditOutlined style={{ fontSize: '12x' }} />
                        </EditTopic>
                    )}
                    <CreateTopic style={{ position: 'static' }} onClick={handleCreatedTopic}>
                        Create Topic
                        {StyledAddIcon}
                    </CreateTopic>
                </div>
            )}
            {typeof job_id == 'number' && (
                <CreateTopic onClick={handleRedirectNexus}>
                    Agent Nexus
                </CreateTopic>
            )}
        </HeaderWrapper>
    );
};


export default ReportHeaderFile;